// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DocumentForm-module__font-s-10___KfeSy {
  font-size: 10px !important;
}

.DocumentForm-module__font-s-12___bhj1T {
  font-size: 12px !important;
}

.DocumentForm-module__font-s-13___lorUT {
  font-size: 13px !important;
}

.DocumentForm-module__font-s-14___DROPq {
  font-size: 14px !important;
}

.DocumentForm-module__font-s-15___iVbEL {
  font-size: 15px !important;
}

.DocumentForm-module__font-s-16___jpuzM {
  font-size: 16px !important;
}

.DocumentForm-module__font-s-18___RYU5_ {
  font-size: 18px !important;
}

.DocumentForm-module__font-s-20___yMVYB {
  font-size: 20px !important;
}

.DocumentForm-module__font-s-22___UBCo_ {
  font-size: 22px !important;
}

.DocumentForm-module__font-s-28___wP5YU {
  font-size: 28px !important;
}

.DocumentForm-module__font-w-400___dvIJB {
  font-weight: 400 !important;
}

.DocumentForm-module__font-w-500___DN3SE {
  font-weight: 500 !important;
}

.DocumentForm-module__font-w-600___DPwsv {
  font-weight: 600 !important;
}

.DocumentForm-module__font-w-700___TDvuK {
  font-weight: 700 !important;
}

.DocumentForm-module__p-5___i3Ygh {
  padding: 5px !important;
}

.DocumentForm-module__p-12___Lynru {
  padding: 12px !important;
}

.DocumentForm-module__p-16___epGDi {
  padding: 16px !important;
}

.DocumentForm-module__p-30___zbHP1 {
  padding: 30px !important;
}

.DocumentForm-module__p-b-0___iYnVG {
  padding-bottom: 0 !important;
}

.DocumentForm-module__p-b-5___zemt2 {
  padding-bottom: 5px !important;
}

.DocumentForm-module__p-b-10___zqJAx {
  padding-bottom: 10px !important;
}

.DocumentForm-module__p-b-12___SjyKe {
  padding-bottom: 12px !important;
}

.DocumentForm-module__p-b-16___N2XGP {
  padding-bottom: 16px !important;
}

.DocumentForm-module__p-b-18___wcvf1 {
  padding-bottom: 18px !important;
}

.DocumentForm-module__p-b-20___SKCI4 {
  padding-bottom: 20px !important;
}

.DocumentForm-module__p-b-25___qpwLd {
  padding-bottom: 25px !important;
}

.DocumentForm-module__p-b-30___XmrTE {
  padding-bottom: 30px !important;
}

.DocumentForm-module__p-b-50___Rsztv {
  padding-bottom: 50px !important;
}

.DocumentForm-module__p-t-0___ovc4O {
  padding-top: 0 !important;
}

.DocumentForm-module__p-t-12___ELY1D {
  padding-top: 12px !important;
}

.DocumentForm-module__p-t-16____gfkQ {
  padding-top: 16px !important;
}

.DocumentForm-module__p-t-18___eWO6C {
  padding-top: 18px !important;
}

.DocumentForm-module__p-t-20___LN32s {
  padding-top: 20px !important;
}

.DocumentForm-module__p-t-30___w9DJ4 {
  padding-top: 30px !important;
}

.DocumentForm-module__p-t-40___yTam4 {
  padding-top: 40px !important;
}

.DocumentForm-module__p-t-50___JNLJn {
  padding-top: 50px !important;
}

.DocumentForm-module__p-l-20___V9E35 {
  padding-left: 20px !important;
}

.DocumentForm-module__p-l-30___AsVEN {
  padding-left: 30px !important;
}

.DocumentForm-module__p-l-40___cWpis {
  padding-left: 40px !important;
}

.DocumentForm-module__p-r-16___QKy4r {
  padding-right: 16px !important;
}

.DocumentForm-module__p-r-20___zvOJC {
  padding-right: 20px !important;
}

.DocumentForm-module__p-r-30___d6sxc {
  padding-right: 30px !important;
}

.DocumentForm-module__p-r-50___Q6YOw {
  padding-right: 50px !important;
}

.DocumentForm-module__p-r-60___qevF6 {
  padding-right: 60px !important;
}

.DocumentForm-module__m-b-1___XLfYE {
  margin-bottom: 1px !important;
}

.DocumentForm-module__m-b-2____AjD4 {
  margin-bottom: 2px !important;
}

.DocumentForm-module__m-b-6___TWp0H {
  margin-bottom: 6px !important;
}

.DocumentForm-module__m-b-8___Huxnu {
  margin-bottom: 8px !important;
}

.DocumentForm-module__m-b-10___xY6P0 {
  margin-bottom: 10px !important;
}

.DocumentForm-module__m-b-14___cTYC0 {
  margin-bottom: 14px !important;
}

.DocumentForm-module__m-b-16___EEW2y {
  margin-bottom: 16px !important;
}

.DocumentForm-module__m-b-20___qsWju {
  margin-bottom: 20px !important;
}

.DocumentForm-module__m-b-22___VZHYa {
  margin-bottom: 22px !important;
}

.DocumentForm-module__m-b-24___wbp4A {
  margin-bottom: 24px !important;
}

.DocumentForm-module__m-b-30___Lm45i {
  margin-bottom: 30px !important;
}

.DocumentForm-module__m-b-32___MDTJl {
  margin-bottom: 32px !important;
}

.DocumentForm-module__m-b-40___rBlKc {
  margin-bottom: 40px !important;
}

.DocumentForm-module__m-t-2___k4CXm {
  margin-top: 2px !important;
}

.DocumentForm-module__m-t-3___T9XwP {
  margin-top: 3px !important;
}

.DocumentForm-module__m-t-4___JLTDt {
  margin-top: 4px !important;
}

.DocumentForm-module__m-t-5___tGr89 {
  margin-top: 5px !important;
}

.DocumentForm-module__m-t-8___iAQ00 {
  margin-top: 8px !important;
}

.DocumentForm-module__m-t-10___fyJ6F {
  margin-top: 10px !important;
}

.DocumentForm-module__m-t-15___MVPsN {
  margin-top: 15px !important;
}

.DocumentForm-module__m-t-16___rJwUi {
  margin-top: 16px !important;
}

.DocumentForm-module__m-t-20___Lszoq {
  margin-top: 20px !important;
}

.DocumentForm-module__m-t-22___TRpH0 {
  margin-top: 22px !important;
}

.DocumentForm-module__m-t-30___p5Fgd {
  margin-top: 30px !important;
}

.DocumentForm-module__m-t-32___uCr9C {
  margin-top: 32px !important;
}

.DocumentForm-module__m-l-auto___WM62E {
  margin-left: auto !important;
}

.DocumentForm-module__m-l-4___RpP0Q {
  margin-left: 4px !important;
}

.DocumentForm-module__m-l-5___ISyGy {
  margin-left: 5px !important;
}

.DocumentForm-module__m-l-6___EhXbR {
  margin-left: 6px !important;
}

.DocumentForm-module__m-l-8___Xd8nw {
  margin-left: 8px !important;
}

.DocumentForm-module__m-l-10___AZcCL {
  margin-left: 10px !important;
}

.DocumentForm-module__m-l-16___FZCWC {
  margin-left: 16px !important;
}

.DocumentForm-module__m-l-20___DOeS8 {
  margin-left: 20px !important;
}

.DocumentForm-module__m-l-24___rjMN5 {
  margin-left: 24px !important;
}

.DocumentForm-module__m-l-30___W5r8x {
  margin-left: 30px !important;
}

.DocumentForm-module__m-l-35___GgIZd {
  margin-left: 35px !important;
}

.DocumentForm-module__m-l-40___qeYbj {
  margin-left: 40px !important;
}

.DocumentForm-module__m-r-8___BlefW {
  margin-right: 8px !important;
}

.DocumentForm-module__m-r-10___Zbbtt {
  margin-right: 10px !important;
}

.DocumentForm-module__m-r-16___QrU9X {
  margin-right: 16px !important;
}

.DocumentForm-module__m-r-20___h4De8 {
  margin-right: 20px !important;
}

.DocumentForm-module__m-r-24___vHVLN {
  margin-right: 24px !important;
}

.DocumentForm-module__m-r-30___ShzVW {
  margin-right: 30px !important;
}

.DocumentForm-module__m-r-40___HtlEn {
  margin-right: 40px !important;
}

.DocumentForm-module__border-r-3___KKciP {
  border-radius: 3px !important;
}

.DocumentForm-module__border-r-4___lL_zo {
  border-radius: 4px !important;
}

.DocumentForm-module__border-r-6___v7gNn {
  border-radius: 6px !important;
}

.DocumentForm-module__border-r-10___FRoDO {
  border-radius: 10px !important;
}

.DocumentForm-module__border-r-12___s0Y36 {
  border-radius: 12px !important;
}

.DocumentForm-module__border-r-16___u8RG1 {
  border-radius: 16px !important;
}

.DocumentForm-module__border-r-50___gZAts {
  border-radius: 50% !important;
}

.DocumentForm-module__primary-border___pPXQv {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.DocumentForm-module__primary-border-b___CTscC {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.DocumentForm-module__primary-border-t___uC6go {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.DocumentForm-module__primary-border-l___DYM11 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.DocumentForm-module__primary-border-r___f8WHe {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.DocumentForm-module__secondary-border___XnWWl {
  border: 1px solid #637768;
}

.DocumentForm-module__secondary-border-b___dZGVN {
  border-bottom: 1px solid #637768;
}

.DocumentForm-module__secondary-border-t___Wv9YV {
  border-top: 1px solid #637768;
}

.DocumentForm-module__secondary-border-l___s11Gm {
  border-left: 1px solid #637768;
}

.DocumentForm-module__secondary-border-r___CofIv {
  border-right: 1px solid #637768;
}

.DocumentForm-module__gap-0___RrRxX {
  gap: 0 !important;
}

.DocumentForm-module__gap-2___IMZnD {
  gap: 2px !important;
}

.DocumentForm-module__gap-4___itrDE {
  gap: 4px !important;
}

.DocumentForm-module__gap-5___N0s31 {
  gap: 5px !important;
}

.DocumentForm-module__gap-6___iAy0h {
  gap: 6px !important;
}

.DocumentForm-module__gap-8___ZAm6A {
  gap: 8px !important;
}

.DocumentForm-module__gap-10___WhvM5 {
  gap: 10px !important;
}

.DocumentForm-module__gap-12___MibQ8 {
  gap: 12px !important;
}

.DocumentForm-module__gap-14___iH0Lk {
  gap: 14px !important;
}

.DocumentForm-module__gap-16___uyegP {
  gap: 16px !important;
}

.DocumentForm-module__gap-18___FP6s8 {
  gap: 18px !important;
}

.DocumentForm-module__gap-20___jkn4n {
  gap: 20px !important;
}

.DocumentForm-module__gap-24___hGdD8 {
  gap: 24px !important;
}

.DocumentForm-module__gap-26___rh7pF {
  gap: 26px !important;
}

.DocumentForm-module__gap-30___Qu2ov {
  gap: 30px !important;
}

.DocumentForm-module__gap-32___ymY4I {
  gap: 32px !important;
}

.DocumentForm-module__gap-40___VAwFl {
  gap: 40px !important;
}

.DocumentForm-module__gap-50___E0p7u {
  gap: 50px !important;
}

.DocumentForm-module__flex-1___v1RRn {
  flex: 1;
}

.DocumentForm-module__flex-none___B5_2H {
  flex: none !important;
}

.DocumentForm-module__flex-column___MEPvD {
  display: flex;
  flex-direction: column !important;
}

.DocumentForm-module__flex-row___TJxud {
  display: flex;
  flex-direction: row !important;
}

.DocumentForm-module__vertically-centered___JEX6f {
  display: flex;
  align-items: center !important;
}

.DocumentForm-module__horizontally-centered___SnUlj {
  display: flex;
  justify-content: center !important;
}

.DocumentForm-module__horizontally-end___Rgzow {
  display: flex;
  justify-content: end !important;
}

.DocumentForm-module__vertically-start___h6jIE {
  display: flex;
  align-items: start !important;
}

.DocumentForm-module__space-between___cdRyr {
  display: flex;
  justify-content: space-between !important;
}

.DocumentForm-module__flex-wrap___m6yK1 {
  flex-wrap: wrap !important;
}

.DocumentForm-module__height-100___qCGba {
  height: 100%;
}

.DocumentForm-module__width-50___WtnPE {
  width: 50% !important;
}

.DocumentForm-module__width-100___QyWiI {
  width: 100%;
}

.DocumentForm-module__cursor-pointer___vaQs7 {
  cursor: pointer;
}

.DocumentForm-module__cursor-not-allowed___g58bl {
  cursor: not-allowed !important;
}

.DocumentForm-module__absolute-centered___ZDjn2 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.DocumentForm-module__absolute___j3aMq {
  position: absolute;
}

.DocumentForm-module__relative___lqqqj {
  position: relative;
}

.DocumentForm-module__fixed___ek5S9 {
  position: fixed;
}

.DocumentForm-module__visible___sRT2K {
  opacity: 1;
}

.DocumentForm-module__invisible___O2buP {
  opacity: 0;
}

.DocumentForm-module__col-90___cf90r {
  width: 90% !important;
}

.DocumentForm-module__col-auto___IjHQP {
  width: auto !important;
}

.DocumentForm-module__medical-tabs___bO_8c {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.DocumentForm-module__medical-table-new___h_nPK {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DocumentForm-module__medical-table-new___h_nPK:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DocumentForm-module__medical-table-new___h_nPK::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DocumentForm-module__medical-table-new___h_nPK::-webkit-scrollbar-track {
  display: none;
}
.DocumentForm-module__medical-table-new___h_nPK.DocumentForm-module__no-pagination___lwBoP {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DocumentForm-module__medical-table-new___h_nPK.DocumentForm-module__no-pagination___lwBoP:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DocumentForm-module__medical-table-new___h_nPK.DocumentForm-module__no-pagination___lwBoP::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DocumentForm-module__medical-table-new___h_nPK.DocumentForm-module__no-pagination___lwBoP::-webkit-scrollbar-track {
  display: none;
}

.DocumentForm-module__medical-table-empty___REwY_ {
  padding: 14px 40px !important;
}

.DocumentForm-module__icon-btn___sge2_ {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.DocumentForm-module__search-icon___Tp3oB {
  width: 24px;
  height: 24px;
  align-self: center;
}

.DocumentForm-module__disable-select___ddWJv {
  user-select: none;
}

.DocumentForm-module__break-word___DP7QK {
  word-break: break-word;
}

.DocumentForm-module__popup-clear-btn____h3JD {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.DocumentForm-module__scroll-m-b-20___KTivb {
  scroll-margin-bottom: 20px;
}

.DocumentForm-module__templateInstructions___I4uYB {
  color: #375844;
}
.DocumentForm-module__templateInstructions___I4uYB + [id^=content] {
  padding-left: 50px;
}

.DocumentForm-module__contentWrapper___nFOz6 {
  padding: 0 45px 24px 30px;
}
.DocumentForm-module__contentWrapper___nFOz6 .DocumentForm-module__header___Xyt7d {
  color: #375844;
  white-space: break-spaces;
  scroll-margin: 10px;
}
.DocumentForm-module__contentWrapper___nFOz6 .DocumentForm-module__header___Xyt7d:has(+ [id^=question]) {
  margin-bottom: 11px;
}
.DocumentForm-module__contentWrapper___nFOz6 .DocumentForm-module__header___Xyt7d .DocumentForm-module__linkedText___EvcJ_ {
  color: #375844;
  text-decoration-line: underline;
}
.DocumentForm-module__contentWrapper___nFOz6 .DocumentForm-module__questionWrapper___mHDtf {
  scroll-margin: 10px;
}
.DocumentForm-module__contentWrapper___nFOz6 .DocumentForm-module__questionWrapper___mHDtf .DocumentForm-module__label___XFQAZ {
  color: #637768;
}
.DocumentForm-module__contentWrapper___nFOz6 .DocumentForm-module__questionWrapper___mHDtf .DocumentForm-module__label___XFQAZ .DocumentForm-module__asterisk___lXl3O {
  color: #f06c67;
}
.DocumentForm-module__contentWrapper___nFOz6 .DocumentForm-module__questionWrapper___mHDtf .DocumentForm-module__label___XFQAZ.DocumentForm-module__withError___RA9ov {
  color: #db2828;
}
.DocumentForm-module__contentWrapper___nFOz6 .DocumentForm-module__questionWrapper___mHDtf .DocumentForm-module__input___qejLO {
  min-width: 250px;
  width: 66%;
}
.DocumentForm-module__contentWrapper___nFOz6 .DocumentForm-module__questionWrapper___mHDtf .DocumentForm-module__number___CLene {
  min-width: 250px;
  width: 33%;
}
.DocumentForm-module__contentWrapper___nFOz6 .DocumentForm-module__questionWrapper___mHDtf .DocumentForm-module__radio___tKpEo {
  font-weight: 400 !important;
}
.DocumentForm-module__contentWrapper___nFOz6 .DocumentForm-module__questionWrapper___mHDtf .DocumentForm-module__radio___tKpEo.DocumentForm-module__row___EDEUj {
  margin-bottom: 0 !important;
}
.DocumentForm-module__contentWrapper___nFOz6 .DocumentForm-module__questionWrapper___mHDtf .DocumentForm-module__radio___tKpEo + span + button, .DocumentForm-module__contentWrapper___nFOz6 .DocumentForm-module__questionWrapper___mHDtf .DocumentForm-module__radio___tKpEo + button {
  margin-left: 0 !important;
  padding: 0 !important;
  min-width: auto !important;
  font-size: 12px !important;
  color: #bcbec0 !important;
}
.DocumentForm-module__contentWrapper___nFOz6 .DocumentForm-module__questionWrapper___mHDtf .DocumentForm-module__radio___tKpEo > div {
  border: 1px solid #d3d3d3;
  min-width: 16px;
  min-height: 16px;
}
.DocumentForm-module__contentWrapper___nFOz6 .DocumentForm-module__questionWrapper___mHDtf .DocumentForm-module__radio___tKpEo > div span {
  width: 8px !important;
  height: 8px !important;
}
.DocumentForm-module__contentWrapper___nFOz6 .DocumentForm-module__questionWrapper___mHDtf .DocumentForm-module__date___RFHFU {
  width: 300px !important;
}
.DocumentForm-module__contentWrapper___nFOz6 .DocumentForm-module__questionWrapper___mHDtf .DocumentForm-module__multiSelect___WYlmN {
  min-width: 250px;
  width: 33% !important;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/components/DocumentForm/DocumentForm.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;AA8pBF;AA5pBE;EACE,kBAAA;AA8pBJ;;AA1pBA;EACE,yBAAA;AA6pBF;AA3pBE;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;AA6pBJ;AA3pBI;EACE,mBAAA;AA6pBN;AA1pBI;EACE,cAAA;EACA,+BAAA;AA4pBN;AAxpBE;EACE,mBAAA;AA0pBJ;AAxpBI;EACE,cAAA;AA0pBN;AAxpBM;EACE,cAAA;AA0pBR;AAvpBM;EACE,cAAA;AAypBR;AArpBI;EACE,gBAAA;EACA,UAAA;AAupBN;AAppBI;EACE,gBAAA;EACA,UAAA;AAspBN;AAnpBI;EACE,2BAAA;AAqpBN;AAnpBM;EACE,2BAAA;AAqpBR;AAlpBM;EAEE,yBAAA;EACA,qBAAA;EACA,0BAAA;EACA,0BAAA;EACA,yBAAA;AAmpBR;AAhpBM;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;AAkpBR;AAhpBQ;EACE,qBAAA;EACA,sBAAA;AAkpBV;AA7oBI;EACE,uBAAA;AA+oBN;AA5oBI;EACE,gBAAA;EACA,qBAAA;AA8oBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.templateInstructions {\n  color: get-color(greenNew, dark);\n\n  & + [id^='content'] {\n    padding-left: 50px;\n  }\n}\n\n.contentWrapper {\n  padding: 0 45px 24px 30px;\n\n  .header {\n    color: get-color(greenNew, dark);\n    white-space: break-spaces;\n    scroll-margin: 10px;\n\n    &:has(+ [id^='question']) {\n      margin-bottom: 11px;\n    }\n\n    .linkedText {\n      color: get-color(greenNew, dark);\n      text-decoration-line: underline;\n    }\n  }\n\n  .questionWrapper {\n    scroll-margin: 10px;\n\n    .label {\n      color: get-color(greenNew, medium-dark);\n\n      .asterisk {\n        color: get-color(redNew, medium-dark);\n      }\n\n      &.withError {\n        color: get-color(redNew, medium);\n      }\n    }\n\n    .input {\n      min-width: 250px;\n      width: 66%;\n    }\n\n    .number {\n      min-width: 250px;\n      width: 33%;\n    }\n\n    .radio {\n      font-weight: 400 !important;\n\n      &.row {\n        margin-bottom: 0 !important;\n      }\n\n      & + span + button,\n      & + button {\n        margin-left: 0 !important;\n        padding: 0 !important;\n        min-width: auto !important;\n        font-size: 12px !important;\n        color: get-color(gray, medium) !important;\n      }\n\n      & > div {\n        border: 1px solid get-color(gray);\n        min-width: 16px;\n        min-height: 16px;\n\n        span {\n          width: 8px !important;\n          height: 8px !important;\n        }\n      }\n    }\n\n    .date {\n      width: 300px !important;\n    }\n\n    .multiSelect {\n      min-width: 250px;\n      width: 33% !important;\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `DocumentForm-module__font-s-10___KfeSy`,
	"fontS12": `DocumentForm-module__font-s-12___bhj1T`,
	"fontS13": `DocumentForm-module__font-s-13___lorUT`,
	"fontS14": `DocumentForm-module__font-s-14___DROPq`,
	"fontS15": `DocumentForm-module__font-s-15___iVbEL`,
	"fontS16": `DocumentForm-module__font-s-16___jpuzM`,
	"fontS18": `DocumentForm-module__font-s-18___RYU5_`,
	"fontS20": `DocumentForm-module__font-s-20___yMVYB`,
	"fontS22": `DocumentForm-module__font-s-22___UBCo_`,
	"fontS28": `DocumentForm-module__font-s-28___wP5YU`,
	"fontW400": `DocumentForm-module__font-w-400___dvIJB`,
	"fontW500": `DocumentForm-module__font-w-500___DN3SE`,
	"fontW600": `DocumentForm-module__font-w-600___DPwsv`,
	"fontW700": `DocumentForm-module__font-w-700___TDvuK`,
	"p5": `DocumentForm-module__p-5___i3Ygh`,
	"p12": `DocumentForm-module__p-12___Lynru`,
	"p16": `DocumentForm-module__p-16___epGDi`,
	"p30": `DocumentForm-module__p-30___zbHP1`,
	"pB0": `DocumentForm-module__p-b-0___iYnVG`,
	"pB5": `DocumentForm-module__p-b-5___zemt2`,
	"pB10": `DocumentForm-module__p-b-10___zqJAx`,
	"pB12": `DocumentForm-module__p-b-12___SjyKe`,
	"pB16": `DocumentForm-module__p-b-16___N2XGP`,
	"pB18": `DocumentForm-module__p-b-18___wcvf1`,
	"pB20": `DocumentForm-module__p-b-20___SKCI4`,
	"pB25": `DocumentForm-module__p-b-25___qpwLd`,
	"pB30": `DocumentForm-module__p-b-30___XmrTE`,
	"pB50": `DocumentForm-module__p-b-50___Rsztv`,
	"pT0": `DocumentForm-module__p-t-0___ovc4O`,
	"pT12": `DocumentForm-module__p-t-12___ELY1D`,
	"pT16": `DocumentForm-module__p-t-16____gfkQ`,
	"pT18": `DocumentForm-module__p-t-18___eWO6C`,
	"pT20": `DocumentForm-module__p-t-20___LN32s`,
	"pT30": `DocumentForm-module__p-t-30___w9DJ4`,
	"pT40": `DocumentForm-module__p-t-40___yTam4`,
	"pT50": `DocumentForm-module__p-t-50___JNLJn`,
	"pL20": `DocumentForm-module__p-l-20___V9E35`,
	"pL30": `DocumentForm-module__p-l-30___AsVEN`,
	"pL40": `DocumentForm-module__p-l-40___cWpis`,
	"pR16": `DocumentForm-module__p-r-16___QKy4r`,
	"pR20": `DocumentForm-module__p-r-20___zvOJC`,
	"pR30": `DocumentForm-module__p-r-30___d6sxc`,
	"pR50": `DocumentForm-module__p-r-50___Q6YOw`,
	"pR60": `DocumentForm-module__p-r-60___qevF6`,
	"mB1": `DocumentForm-module__m-b-1___XLfYE`,
	"mB2": `DocumentForm-module__m-b-2____AjD4`,
	"mB6": `DocumentForm-module__m-b-6___TWp0H`,
	"mB8": `DocumentForm-module__m-b-8___Huxnu`,
	"mB10": `DocumentForm-module__m-b-10___xY6P0`,
	"mB14": `DocumentForm-module__m-b-14___cTYC0`,
	"mB16": `DocumentForm-module__m-b-16___EEW2y`,
	"mB20": `DocumentForm-module__m-b-20___qsWju`,
	"mB22": `DocumentForm-module__m-b-22___VZHYa`,
	"mB24": `DocumentForm-module__m-b-24___wbp4A`,
	"mB30": `DocumentForm-module__m-b-30___Lm45i`,
	"mB32": `DocumentForm-module__m-b-32___MDTJl`,
	"mB40": `DocumentForm-module__m-b-40___rBlKc`,
	"mT2": `DocumentForm-module__m-t-2___k4CXm`,
	"mT3": `DocumentForm-module__m-t-3___T9XwP`,
	"mT4": `DocumentForm-module__m-t-4___JLTDt`,
	"mT5": `DocumentForm-module__m-t-5___tGr89`,
	"mT8": `DocumentForm-module__m-t-8___iAQ00`,
	"mT10": `DocumentForm-module__m-t-10___fyJ6F`,
	"mT15": `DocumentForm-module__m-t-15___MVPsN`,
	"mT16": `DocumentForm-module__m-t-16___rJwUi`,
	"mT20": `DocumentForm-module__m-t-20___Lszoq`,
	"mT22": `DocumentForm-module__m-t-22___TRpH0`,
	"mT30": `DocumentForm-module__m-t-30___p5Fgd`,
	"mT32": `DocumentForm-module__m-t-32___uCr9C`,
	"mLAuto": `DocumentForm-module__m-l-auto___WM62E`,
	"mL4": `DocumentForm-module__m-l-4___RpP0Q`,
	"mL5": `DocumentForm-module__m-l-5___ISyGy`,
	"mL6": `DocumentForm-module__m-l-6___EhXbR`,
	"mL8": `DocumentForm-module__m-l-8___Xd8nw`,
	"mL10": `DocumentForm-module__m-l-10___AZcCL`,
	"mL16": `DocumentForm-module__m-l-16___FZCWC`,
	"mL20": `DocumentForm-module__m-l-20___DOeS8`,
	"mL24": `DocumentForm-module__m-l-24___rjMN5`,
	"mL30": `DocumentForm-module__m-l-30___W5r8x`,
	"mL35": `DocumentForm-module__m-l-35___GgIZd`,
	"mL40": `DocumentForm-module__m-l-40___qeYbj`,
	"mR8": `DocumentForm-module__m-r-8___BlefW`,
	"mR10": `DocumentForm-module__m-r-10___Zbbtt`,
	"mR16": `DocumentForm-module__m-r-16___QrU9X`,
	"mR20": `DocumentForm-module__m-r-20___h4De8`,
	"mR24": `DocumentForm-module__m-r-24___vHVLN`,
	"mR30": `DocumentForm-module__m-r-30___ShzVW`,
	"mR40": `DocumentForm-module__m-r-40___HtlEn`,
	"borderR3": `DocumentForm-module__border-r-3___KKciP`,
	"borderR4": `DocumentForm-module__border-r-4___lL_zo`,
	"borderR6": `DocumentForm-module__border-r-6___v7gNn`,
	"borderR10": `DocumentForm-module__border-r-10___FRoDO`,
	"borderR12": `DocumentForm-module__border-r-12___s0Y36`,
	"borderR16": `DocumentForm-module__border-r-16___u8RG1`,
	"borderR50": `DocumentForm-module__border-r-50___gZAts`,
	"primaryBorder": `DocumentForm-module__primary-border___pPXQv`,
	"primaryBorderB": `DocumentForm-module__primary-border-b___CTscC`,
	"primaryBorderT": `DocumentForm-module__primary-border-t___uC6go`,
	"primaryBorderL": `DocumentForm-module__primary-border-l___DYM11`,
	"primaryBorderR": `DocumentForm-module__primary-border-r___f8WHe`,
	"secondaryBorder": `DocumentForm-module__secondary-border___XnWWl`,
	"secondaryBorderB": `DocumentForm-module__secondary-border-b___dZGVN`,
	"secondaryBorderT": `DocumentForm-module__secondary-border-t___Wv9YV`,
	"secondaryBorderL": `DocumentForm-module__secondary-border-l___s11Gm`,
	"secondaryBorderR": `DocumentForm-module__secondary-border-r___CofIv`,
	"gap0": `DocumentForm-module__gap-0___RrRxX`,
	"gap2": `DocumentForm-module__gap-2___IMZnD`,
	"gap4": `DocumentForm-module__gap-4___itrDE`,
	"gap5": `DocumentForm-module__gap-5___N0s31`,
	"gap6": `DocumentForm-module__gap-6___iAy0h`,
	"gap8": `DocumentForm-module__gap-8___ZAm6A`,
	"gap10": `DocumentForm-module__gap-10___WhvM5`,
	"gap12": `DocumentForm-module__gap-12___MibQ8`,
	"gap14": `DocumentForm-module__gap-14___iH0Lk`,
	"gap16": `DocumentForm-module__gap-16___uyegP`,
	"gap18": `DocumentForm-module__gap-18___FP6s8`,
	"gap20": `DocumentForm-module__gap-20___jkn4n`,
	"gap24": `DocumentForm-module__gap-24___hGdD8`,
	"gap26": `DocumentForm-module__gap-26___rh7pF`,
	"gap30": `DocumentForm-module__gap-30___Qu2ov`,
	"gap32": `DocumentForm-module__gap-32___ymY4I`,
	"gap40": `DocumentForm-module__gap-40___VAwFl`,
	"gap50": `DocumentForm-module__gap-50___E0p7u`,
	"flex1": `DocumentForm-module__flex-1___v1RRn`,
	"flexNone": `DocumentForm-module__flex-none___B5_2H`,
	"flexColumn": `DocumentForm-module__flex-column___MEPvD`,
	"flexRow": `DocumentForm-module__flex-row___TJxud`,
	"verticallyCentered": `DocumentForm-module__vertically-centered___JEX6f`,
	"horizontallyCentered": `DocumentForm-module__horizontally-centered___SnUlj`,
	"horizontallyEnd": `DocumentForm-module__horizontally-end___Rgzow`,
	"verticallyStart": `DocumentForm-module__vertically-start___h6jIE`,
	"spaceBetween": `DocumentForm-module__space-between___cdRyr`,
	"flexWrap": `DocumentForm-module__flex-wrap___m6yK1`,
	"height100": `DocumentForm-module__height-100___qCGba`,
	"width50": `DocumentForm-module__width-50___WtnPE`,
	"width100": `DocumentForm-module__width-100___QyWiI`,
	"cursorPointer": `DocumentForm-module__cursor-pointer___vaQs7`,
	"cursorNotAllowed": `DocumentForm-module__cursor-not-allowed___g58bl`,
	"absoluteCentered": `DocumentForm-module__absolute-centered___ZDjn2`,
	"absolute": `DocumentForm-module__absolute___j3aMq`,
	"relative": `DocumentForm-module__relative___lqqqj`,
	"fixed": `DocumentForm-module__fixed___ek5S9`,
	"visible": `DocumentForm-module__visible___sRT2K`,
	"invisible": `DocumentForm-module__invisible___O2buP`,
	"col90": `DocumentForm-module__col-90___cf90r`,
	"colAuto": `DocumentForm-module__col-auto___IjHQP`,
	"medicalTabs": `DocumentForm-module__medical-tabs___bO_8c`,
	"medicalTableNew": `DocumentForm-module__medical-table-new___h_nPK`,
	"noPagination": `DocumentForm-module__no-pagination___lwBoP`,
	"medicalTableEmpty": `DocumentForm-module__medical-table-empty___REwY_`,
	"iconBtn": `DocumentForm-module__icon-btn___sge2_`,
	"searchIcon": `DocumentForm-module__search-icon___Tp3oB`,
	"disableSelect": `DocumentForm-module__disable-select___ddWJv`,
	"breakWord": `DocumentForm-module__break-word___DP7QK`,
	"popupClearBtn": `DocumentForm-module__popup-clear-btn____h3JD`,
	"scrollMB20": `DocumentForm-module__scroll-m-b-20___KTivb`,
	"templateInstructions": `DocumentForm-module__templateInstructions___I4uYB`,
	"contentWrapper": `DocumentForm-module__contentWrapper___nFOz6`,
	"header": `DocumentForm-module__header___Xyt7d`,
	"linkedText": `DocumentForm-module__linkedText___EvcJ_`,
	"questionWrapper": `DocumentForm-module__questionWrapper___mHDtf`,
	"label": `DocumentForm-module__label___XFQAZ`,
	"asterisk": `DocumentForm-module__asterisk___lXl3O`,
	"withError": `DocumentForm-module__withError___RA9ov`,
	"input": `DocumentForm-module__input___qejLO`,
	"number": `DocumentForm-module__number___CLene`,
	"radio": `DocumentForm-module__radio___tKpEo`,
	"row": `DocumentForm-module__row___EDEUj`,
	"date": `DocumentForm-module__date___RFHFU`,
	"multiSelect": `DocumentForm-module__multiSelect___WYlmN`
};
module.exports = ___CSS_LOADER_EXPORT___;
